import { Card, Image } from 'react-bootstrap'
import { MdPhone } from "react-icons/md";
import userDefault from '../../img/userdefault.png'
import { withTranslation } from 'react-i18next';

function PerfilDoctorInfo({t, doctorInfo, url}) {

    return(<>
        <Card className="shadow-1 formSection doctor-perfil">
            <div className="doctor-info-personal">
                <span className='doctor-nombre'>
                    {`${doctorInfo?.name} ${doctorInfo?.lastName}`}<br/>
                </span>
                {doctorInfo?.espcialityList[0].name}
            </div>
            
            <Image src={doctorInfo?.url_photo !== '' ? doctorInfo?.url_photo : userDefault} roundedCircle className='doctor-foto doctor-foto-lg' />

            <div className="doctor-info-contacto">
                <MdPhone /> {doctorInfo?.phone} <br />
                <span className='doctor-cedula'> {t('cedula_profesional')}: {doctorInfo?.professional_cedula} </span>
            </div>
        </Card>
    </>)
}

export default withTranslation()(PerfilDoctorInfo)